import { RowDataCorporate } from "../../components/CorporatePage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the DealerTable factory
 */
class CorporateRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/corporate/read-range"
        this.accessData = "corporate"
    }

    create(corporate: any): RowDataCorporate {
        const rowDataOrder: RowDataCorporate = {
            uid: corporate.uid,
            fullname: corporate.fullname,
            phone_number: corporate.phone_number,
            email: corporate.email,
            dob: corporate.dob,
            company: corporate.company,
            corporate_card: corporate.corporate_card,
            action: "",

            nric_fullname: corporate.nric_fullname,
            nric: corporate.nric,
            tin: corporate.tin,
            address_line_1: corporate.address_line_1,
            address_line_2: corporate.address_line_2,
            postal: corporate.postal,
            city: corporate.city,
            state: corporate.state,
            country: corporate.country,
            business_phone_number: corporate.business_phone_number,
            sst_registration_number: corporate.sst_registration_number,
            nricImg: corporate.nricImg,
            isVerified: corporate.isVerified,
            
            createdAt: corporate.createdAt,

            ssm_number: corporate.ssm_number,
            msic: corporate.msic,
            submittedAt: corporate.submittedAt,
        };
        return rowDataOrder;
    }

    generateParams(params: any, extra: any) {
        params["new"] = extra.current
        return params
    }
}

let corporateRow: CorporateRow | null = null;

export default function getCorporateRow(): CorporateRow {
    if (corporateRow === null)
        corporateRow = new CorporateRow()
    return corporateRow
}